import { HiBars3 } from "react-icons/hi2";

export const MenuIcon = ({ width, height, color, ...props }) => (
  <HiBars3
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
